(function () {
  'use strict';

  var hero = document.querySelector('.vb-hero');
  if (!hero) return;

  var sectionId = hero.dataset.sectionId;
  var slider    = document.getElementById('vbSlider-' + sectionId);
  var container = slider ? slider.closest('.vb-slider-container') : null;
  if (!slider || !container) return;

  var slides = Array.prototype.slice.call(slider.querySelectorAll('.vb-slide'));
  var total  = slides.length;
  if (total < 1) return;

  var cur      = 0;
  var autoMs   = (parseInt(hero.closest('section') && hero.dataset.slideDuration, 10) || 4) * 1000;
  var autoTimer = null;
  var rafId     = null;

  /* ── TIME-BASED START SLIDE ── */
  function getStartSlide() {
    var h = new Date().getHours();
    if (h >= 5  && h < 12) return 0; // Morning
    if (h >= 12 && h < 17) return 1; // Afternoon
    if (h >= 17 && h < 21) return 2; // Evening
    return 3;                         // Night
  }

  function isMobile() { return window.innerWidth <= 767; }

  /* ── LAZY LOAD: preload next slide's video ── */
  function preloadSlide(idx) {
    var slide = slides[(idx + total) % total];
    if (!slide) return;
    var videos = slide.querySelectorAll('video');
    videos.forEach(function (v) {
      if (v.preload === 'none') {
        v.preload = 'metadata';
        /* Trigger actual network fetch only when 1 slide away */
        if (v.readyState === 0) v.load();
      }
    });
  }

  /* ── Mark active slide (for CSS content-visibility hook) ── */
  function setActiveClass(idx) {
    slides.forEach(function (s, i) {
      s.classList.toggle('vb-slide--active', i === idx);
    });
  }

  /* ── Pause all videos except current ── */
  function pauseOthers(activIdx) {
    slides.forEach(function (s, i) {
      if (i === activIdx) return;
      s.querySelectorAll('video').forEach(function (v) { v.pause(); });
    });
  }

  /* ── Play current slide video (catches autoplay blocks) ── */
  function playSlideVideo(idx) {
    var slide = slides[idx];
    if (!slide) return;
    var videos = slide.querySelectorAll('video');
    videos.forEach(function (v) {
      if (v.paused) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {}); // swallow NotAllowedError
      }
    });
  }

  /* ── DESKTOP SLIDER ── */
  function desktopGo(idx) {
    cur = (idx + total) % total;
    /* Use requestAnimationFrame — avoids forced reflow */
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function () {
      slider.style.transform = 'translateX(-' + (cur * 100) + '%)';
    });
    setActiveClass(cur);
    pauseOthers(cur);
    playSlideVideo(cur);
    preloadSlide(cur + 1); // preload next
    updateNav();
  }

  function updateNav() {
    var prev = hero.querySelector('.vb-prev');
    var next = hero.querySelector('.vb-next');
    if (prev) prev.disabled = (cur === 0);
    if (next) next.disabled = (cur === total - 1);
  }

  function startDesktopAuto() {
    stopAuto();
    autoTimer = setInterval(function () {
      desktopGo(cur < total - 1 ? cur + 1 : 0);
    }, autoMs);
  }

  /* ── MOBILE SCROLL AUTO ── */
  function mobileScrollTo(idx) {
    var slideW = container.offsetWidth;
    container.scrollTo({ left: idx * slideW, behavior: 'smooth' });
  }

  function startMobileAuto() {
    stopAuto();
    autoTimer = setInterval(function () {
      var slideW = container.offsetWidth;
      var next   = Math.round(container.scrollLeft / slideW) + 1;
      if (next >= total) next = 0;
      mobileScrollTo(next);
    }, autoMs);
  }

  function stopAuto() {
    if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
  }

  /* ── Intersection Observer: pause video when section off-screen ── */
  function setupVisibilityPause() {
    if (!('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var vids = hero.querySelectorAll('video');
        if (entry.isIntersecting) {
          stopAuto();
          isMobile() ? startMobileAuto() : startDesktopAuto();
          playSlideVideo(cur);
        } else {
          stopAuto();
          vids.forEach(function (v) { v.pause(); });
        }
      });
    }, { threshold: 0.1 });
    obs.observe(hero);
  }

  /* ── INIT ── */
  function init() {
    var startSlide = Math.min(getStartSlide(), total - 1);
    cur = startSlide;

    setActiveClass(cur);

    if (isMobile()) {
      slider.style.transform = '';
      container.scrollLeft   = cur * container.offsetWidth;

      startMobileAuto();
      container.addEventListener('touchstart', stopAuto,          { passive: true });
      container.addEventListener('touchend',   startMobileAuto,   { passive: true });

    } else {
      slider.style.transform = 'translateX(-' + (cur * 100) + '%)';
      updateNav();
      startDesktopAuto();

      var prev = hero.querySelector('.vb-prev');
      var next = hero.querySelector('.vb-next');
      if (prev) prev.addEventListener('click', function () { stopAuto(); desktopGo(cur - 1); startDesktopAuto(); });
      if (next) next.addEventListener('click', function () { stopAuto(); desktopGo(cur + 1); startDesktopAuto(); });

      /* Touch swipe on desktop too */
      var tx = 0;
      slider.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend',   function (e) {
        var d = tx - e.changedTouches[0].clientX;
        if (Math.abs(d) > 40) { stopAuto(); desktopGo(d > 0 ? cur + 1 : cur - 1); startDesktopAuto(); }
      }, { passive: true });
    }

    /* Preload the next slide right away */
    preloadSlide(cur + 1);
    setupVisibilityPause();
  }

  /* ── Re-init on resize (mobile ↔ desktop switch) ── */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      stopAuto();
      slider.style.transform = '';
      container.scrollLeft   = 0;
      cur = 0;
      init();
    }, 200);
  });

  init();
})();